const SamePriceCheck = (props: { setSameWithSecondary: any }) => {
    const { setSameWithSecondary } = props;

    const handleCheckboxChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSameWithSecondary(event.target.checked);
    };

    return (
        <div className="flex items-center my-1 ml-2">
            <label className="mr-2 text-gray-600">Same with sales price</label>
            <input onChange={handleCheckboxChange} type="checkbox" />
        </div>
    );
};

export default SamePriceCheck;
